// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_colorPickerWrapper__F9omt {
    padding: 20px;
  }
  
  .styles_colorPickerBasicColor__FbyWf {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    margin: 0;
    padding: 0;
  }
  
  .styles_color-picker-basic-color__ByLV9 button {
    width: 16px;
    height: 16px;

    list-style-type: none;

    cursor: pointer;

    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .styles_ButtonActive__nbSDS {
    box-shadow: 0 0 2px 2px rgb(0 0 0 / 30%);
  }
  
  .styles_colorPickerSaturation__Afc8R {
    position: relative;

    width: 100%;
    height: 150px;

    -webkit-user-select: none;

            user-select: none;

    background-image: linear-gradient(transparent, black),
      linear-gradient(to right, white, transparent);
  }

  .styles_colorPickerSaturationCursor__9pNwy {
    position: absolute;

    box-sizing: border-box;
    width: 20px;
    height: 20px;

    transform: translate(-10px, -10px);

    border: 1px solid #fff;
    border-radius: 50%;
    box-shadow: 0 0 15px #00000026;
  }

  .styles_colorPickerHue__JeUhJ {
    position: relative;

    width: 100%;
    height: 12px;
    margin-top: 20px;

    -webkit-user-select: none;

            user-select: none;

    border-radius: 12px;
    background-image: linear-gradient(
      to right,
      rgb(255 0 0),
      rgb(255 255 0),
      rgb(0 255 0),
      rgb(0 255 255),
      rgb(0 0 255),
      rgb(255 0 255),
      rgb(255 0 0)
    );
  }
  
  .styles_colorPickerHueCursor__KKga0 {
    position: absolute;

    box-sizing: border-box;
    width: 20px;
    height: 20px;

    transform: translate(-10px, -4px);

    border: 2px solid #fff;
    border-radius: 50%;
    box-shadow: #0003 0 0 0 0.5px;
  }
  
  .styles_colorPickerColor__EP2M- {
    width: 100%;
    height: 20px;
    margin-top: 15px;

    border: 1px solid #ccc;
  }`, "",{"version":3,"sources":["webpack://./src/components/form/Editor/components/ColorPicker/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;;IAET,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;;IAEZ,qBAAqB;;IAErB,eAAe;;IAEf,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;;IAElB,WAAW;IACX,aAAa;;IAEb,yBAAiB;;YAAjB,iBAAiB;;IAEjB;mDAC+C;EACjD;;EAEA;IACE,kBAAkB;;IAElB,sBAAsB;IACtB,WAAW;IACX,YAAY;;IAEZ,kCAAkC;;IAElC,sBAAsB;IACtB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;;IAElB,WAAW;IACX,YAAY;IACZ,gBAAgB;;IAEhB,yBAAiB;;YAAjB,iBAAiB;;IAEjB,mBAAmB;IACnB;;;;;;;;;KASC;EACH;;EAEA;IACE,kBAAkB;;IAElB,sBAAsB;IACtB,WAAW;IACX,YAAY;;IAEZ,iCAAiC;;IAEjC,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;;IAEhB,sBAAsB;EACxB","sourcesContent":[".colorPickerWrapper {\n    padding: 20px;\n  }\n  \n  .colorPickerBasicColor {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n\n    margin: 0;\n    padding: 0;\n  }\n  \n  .color-picker-basic-color button {\n    width: 16px;\n    height: 16px;\n\n    list-style-type: none;\n\n    cursor: pointer;\n\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  .ButtonActive {\n    box-shadow: 0 0 2px 2px rgb(0 0 0 / 30%);\n  }\n  \n  .colorPickerSaturation {\n    position: relative;\n\n    width: 100%;\n    height: 150px;\n\n    user-select: none;\n\n    background-image: linear-gradient(transparent, black),\n      linear-gradient(to right, white, transparent);\n  }\n\n  .colorPickerSaturationCursor {\n    position: absolute;\n\n    box-sizing: border-box;\n    width: 20px;\n    height: 20px;\n\n    transform: translate(-10px, -10px);\n\n    border: 1px solid #fff;\n    border-radius: 50%;\n    box-shadow: 0 0 15px #00000026;\n  }\n\n  .colorPickerHue {\n    position: relative;\n\n    width: 100%;\n    height: 12px;\n    margin-top: 20px;\n\n    user-select: none;\n\n    border-radius: 12px;\n    background-image: linear-gradient(\n      to right,\n      rgb(255 0 0),\n      rgb(255 255 0),\n      rgb(0 255 0),\n      rgb(0 255 255),\n      rgb(0 0 255),\n      rgb(255 0 255),\n      rgb(255 0 0)\n    );\n  }\n  \n  .colorPickerHueCursor {\n    position: absolute;\n\n    box-sizing: border-box;\n    width: 20px;\n    height: 20px;\n\n    transform: translate(-10px, -4px);\n\n    border: 2px solid #fff;\n    border-radius: 50%;\n    box-shadow: #0003 0 0 0 0.5px;\n  }\n  \n  .colorPickerColor {\n    width: 100%;\n    height: 20px;\n    margin-top: 15px;\n\n    border: 1px solid #ccc;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorPickerWrapper": `styles_colorPickerWrapper__F9omt`,
	"colorPickerBasicColor": `styles_colorPickerBasicColor__FbyWf`,
	"color-picker-basic-color": `styles_color-picker-basic-color__ByLV9`,
	"ButtonActive": `styles_ButtonActive__nbSDS`,
	"colorPickerSaturation": `styles_colorPickerSaturation__Afc8R`,
	"colorPickerSaturationCursor": `styles_colorPickerSaturationCursor__9pNwy`,
	"colorPickerHue": `styles_colorPickerHue__JeUhJ`,
	"colorPickerHueCursor": `styles_colorPickerHueCursor__KKga0`,
	"colorPickerColor": `styles_colorPickerColor__EP2M-`
};
export default ___CSS_LOADER_EXPORT___;
